import { AxiosResponse } from 'axios'
import { apiPaths } from 'configs/apiConfigs'
import { CallResourcesEnum, ICall, ICallTranscripts, IJob } from 'features/calls/types'
import { orderBy } from 'lodash'
import { IPaginatedResponse } from 'types/api'
import { httpCallService, httpClaims } from 'utils/http'

export interface IGetCallsResponse extends IPaginatedResponse {
  data: ICall[]
}
export const getCalls = async (url: string): Promise<IGetCallsResponse> => {
  const { data } = await httpClaims.get(url)
  return data
}

export const startCall = async (oaiClaimId: string, job: IJob): Promise<ICall> => {
  const { data } = await httpClaims.post(apiPaths.claimCalls(oaiClaimId), job)
  return data
}

export const getCall = async (url: string): Promise<ICall> => {
  const { data } = await httpClaims.get(url)
  return data as ICall
}

export const getCallsByClaimId = async (url: string): Promise<ICall[]> => {
  const { data } = await httpClaims.get(url)
  const sortedCalls = orderBy(data.data, 'jobRequested', 'asc')
  return sortedCalls || []
}

export const updateCallNotesApi = async (jobId: string, notes: string): Promise<AxiosResponse<ICall>> => {
  return httpClaims.patch(apiPaths.call(jobId), { jobId, notes })
}

export const getCallResource = async (url: string, type: CallResourcesEnum): Promise<any | ICallTranscripts> => {
  const extraHeaders = {} as { [key: string]: string }
  if (type === CallResourcesEnum.recording) extraHeaders.responseType = 'arraybuffer'

  const { data } = await httpCallService.get(url, { ...extraHeaders })
  return data
}

export const updateCallDisposition = async (jobId: string, disposition: number): Promise<ICall> => {
  const { data } = await httpClaims.patch(apiPaths.call(jobId), { jobId, disposition })
  return data
}

export const getCallDetails = async (claimId: string, callId: string): Promise<ICall> => {
  const { data } = await httpClaims.get(apiPaths.callDetails(claimId, callId))
  return data as ICall
}
